import { reinitDropDown } from "./catalog/sort";
import { reinitFieldSideBarFilter } from "./catalog/side-smart-filter";
const initElements = () => {
	reinitDropDown();
	reinitFieldSideBarFilter();
}
window.initElements = initElements;
const animateDropInfo = (id) => {
	$(`.js-dropInfoList[data-id="${id}"]`).slideToggle(()=> $(this).stop());
}
$(document).on('click', '.js-dropInfoToggle', function(e) {
	e.preventDefault();
	$(this).toggleClass('current');
	animateDropInfo($(this).data('id'));
});

if ($(window).width() >= 1200) {
	$('.js-workIcon').hover(function () {
		$(this).toggleClass('current');
		$('.js-work-hint').addClass('current');
		console.log($(this));
	}, function () {
		$(this).toggleClass('current');
		$('.js-work-hint').removeClass('current');
	});
} else {
	$(document).on('click', '.js-workIcon', function () {
		const $this = $(this);
		const $parent = $(this).closest('.js-communication-work');
		$parent.find('.js-work-hint').fadeToggle('linear', function () {
			$(this).stop()
		});
		$(document).on('click', function(e) {
			if ($(e.target).closest($this).length === 0) {
				$parent.find('.js-work-hint').fadeOut('linear', function () {
					$(this).stop()
				});
			}
		});
	});
}

const height = (id) => {
	const $item = $(`.js-sharesItemBranch[data-id="${id}"]`),
		  $content = $item.find('.js-sharesItemBranch__content'),
		  $list = $item.find('.js-sharesItemBranch__list');
	$item.toggleClass('open');
	if ($item.hasClass('open')) {
		$content.animate({
			maxHeight : $list.height() + 'px'
		}, 300);		
	} else {
		$content.animate({
			maxHeight : 40 + 'px'
		}, 300);		
	}
}
$(document).on('click', '.js-sharesItemBranch-btn', function() {
	height($(this).data('item-id'));
});
if ($(window).width() >= 1200) {
	$('.js-extraMenu__link').hover(function() {
		$(this).toggleClass('current');
		if ($(this).hasClass('current')) {
			$('.js-extraMenu__subMenu').fadeIn('linear', function() { $(this).stop();});
		} else {
			$('.js-extraMenu__subMenu').fadeOut('linear', function() { $(this).stop();} );
		}
	}, function(e) {
		if(!$(e.relatedTarget).hasClass('js-extraMenu__subMenu')) {
			$(this).toggleClass('current');
			if ($(this).hasClass('current')) {
				$('.js-extraMenu__subMenu').fadeIn('linear', function() { $(this).stop();});
			} else {
				$('.js-extraMenu__subMenu').fadeOut('linear', function() { $(this).stop();} );
			}
		}
	});
	$('.js-extraMenu__subMenu').hover(function() {

	}, function() {
		$('.js-extraMenu__link').removeClass('current');
		$('.js-extraMenu__subMenu').fadeOut('linear', function() { $(this).stop();} );
	});
} else if ($(window).width() >= 768) {
	$(document).on('click', '.js-extraMenu__link', function() {
		$(this).toggleClass('current');
		if ($(this).hasClass('current')) {
			$('.js-extraMenu__subMenu').fadeIn('linear', function() { $(this).stop();});
		} else {
			$('.js-extraMenu__subMenu').fadeOut('linear', function() { $(this).stop();} );
		}
	});
} else {
	$(document).on('click', '.js-extraMenu__link', function() {
		$(this).toggleClass('current');
		if ($(this).hasClass('current')) {
			$('.js-extraMenu__mobileSubMenu').fadeIn('linear', function() { $(this).stop();});
		} else {
			$('.js-extraMenu__mobileSubMenu').fadeOut('linear', function() { $(this).stop();} );
		}
	});
	$(document).on('click touchstart', function(e) {
		if ($(e.target).closest('.js-extraMenu__link').length === 0) {
			$('.js-extraMenu__mobileSubMenu').fadeOut('linear', function () { $(this).stop(); });
		}
	});
}

